"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAV_ITEM_MARGIN_SCALE = exports.MOBILE_MENU_HEIGHT = exports.MENU_HEIGHT = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var Icon_1 = __importDefault(require("../Icon"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var MenuGroup_1 = __importDefault(require("./MenuGroup"));
var Button_1 = __importDefault(require("../Button"));
var react_1 = __importStar(require("react"));
var MobileMenuGroup_1 = __importDefault(require("./MobileMenuGroup"));
var ScrollDetector_1 = __importDefault(require("./ScrollDetector"));
var Box_1 = __importDefault(require("../Box"));
var ResponsiveLogo_1 = __importDefault(require("./ResponsiveLogo"));
var ThemeColorMeta_1 = __importDefault(require("./ThemeColorMeta"));
exports.MENU_HEIGHT = 88;
exports.MOBILE_MENU_HEIGHT = 50;
var MOBILE_HERO_BUTTON_HEIGHT = exports.MOBILE_MENU_HEIGHT;
exports.NAV_ITEM_MARGIN_SCALE = 4;
var StyledHeader = styled_1.default.header(function (_a) {
    var _b;
    var theme = _a.theme, colorTheme = _a.colorTheme, scrollEffect = _a.scrollEffect, isHidden = _a.isHidden, zIndex = _a.zIndex;
    return (_b = {
            top: (scrollEffect && isHidden) ? -exports.MOBILE_MENU_HEIGHT : 0,
            right: 0,
            position: 'fixed',
            backgroundColor: colorTheme === 'DARK' ? theme.colors.black : theme.colors.white,
            color: colorTheme === 'DARK' ? theme.colors.contrastText : theme.colors.text,
            width: '100%',
            transition: 'top 0.5s ease',
            zIndex: zIndex
        },
        _b[theme.mediaQueries.md] = {
            top: (scrollEffect && isHidden) ? -exports.MENU_HEIGHT : 0,
        },
        _b);
});
var TopBar = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            height: exports.MOBILE_MENU_HEIGHT,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            paddingLeft: theme.space[4],
            paddingRight: theme.space[4]
        },
        _b[theme.mediaQueries.md] = {
            height: exports.MENU_HEIGHT,
            paddingLeft: theme.space[5],
            paddingRight: theme.space[5],
        },
        _b);
});
var MenuContainer = (0, styled_1.default)(Box_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        maxWidth: theme.maxWidth,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    });
});
var MobileNav = (0, styled_1.default)(Box_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'none',
        backgroundColor: 'inherit',
        position: 'absolute',
        width: '100%',
        padding: theme.space[4],
        // when mobile menu is open
        '&.open': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        },
        '& :not(:last-child)': {
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            borderBottomColor: theme.colors.grey,
        }
    });
});
MobileNav.defaultProps = { as: 'nav' };
var Nav = (0, styled_1.default)(Box_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'none',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        _b[theme.mediaQueries.md] = {
            display: 'flex'
        },
        _b);
});
Nav.defaultProps = { as: 'nav' };
var Divider = (0, styled_1.default)(Box_1.default)(function (_a) {
    var theme = _a.theme, colorTheme = _a.colorTheme;
    return ({
        backgroundColor: colorTheme === 'DARK' ? theme.colors.contrastText : theme.colors.text,
        width: '1px',
        height: '42px',
        marginLeft: theme.space[exports.NAV_ITEM_MARGIN_SCALE]
    });
});
var MobileMenuIcon = (0, styled_1.default)(Icon_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'block'
        },
        _b[theme.mediaQueries.md] = {
            display: 'none'
        },
        _b);
});
var Spacer = (0, styled_1.default)(Box_1.default)(function (props) {
    var _a;
    var theme = props.theme, colorTheme = props.colorTheme;
    return _a = {
            width: '100%',
            height: exports.MOBILE_MENU_HEIGHT + MOBILE_HERO_BUTTON_HEIGHT,
            backgroundColor: colorTheme === 'DARK' ? theme.colors.black : theme.colors.white
        },
        _a[theme.mediaQueries.md] = {
            height: exports.MENU_HEIGHT,
        },
        _a;
});
var Header = function (props) {
    var _a = props || {}, _b = _a.first_set, first_set = _b === void 0 ? [] : _b, _c = _a.second_set, second_set = _c === void 0 ? [] : _c, hero_button = _a.hero_button, isLoggedIn = _a.isLoggedIn, _d = _a.color_theme, color_theme = _d === void 0 ? 'DARK' : _d, _e = _a.scroll_effect, scroll_effect = _e === void 0 ? false : _e, zIndex = _a.zIndex;
    var _f = (0, react_1.useState)(false), menuOpen = _f[0], setMenuOpen = _f[1];
    var _g = (0, react_1.useState)(false), isHidden = _g[0], setIsHidden = _g[1];
    (0, react_1.useEffect)(function () {
        var handleResize = function () {
            setMenuOpen(false);
        };
        window === null || window === void 0 ? void 0 : window.addEventListener('resize', handleResize);
        return function () {
            window === null || window === void 0 ? void 0 : window.removeEventListener('resize', handleResize);
        };
    }, []);
    var handleButtonClick = function () {
        if (hero_button === null || hero_button === void 0 ? void 0 : hero_button.url) {
            window.location.href = hero_button.url;
        }
    };
    var handleScroll = function (scrollPosition, scrollDirection, isBottom) {
        if (scrollPosition <= 0 || // mobile safari will bounce below 0
            scrollDirection === 'DOWN' && scrollPosition < 400 ||
            scrollDirection === 'UP' && scrollPosition > 0 && !isBottom) { // mobile safari will bounce at bottom
            setIsHidden(false);
        }
        else {
            setIsHidden(true);
            setMenuOpen(false);
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ThemeColorMeta_1.default, { colorTheme: color_theme }),
        scroll_effect && react_1.default.createElement(ScrollDetector_1.default, { onScroll: handleScroll }),
        react_1.default.createElement(StyledHeader, { id: 'ff-ui-header', colorTheme: color_theme, scrollEffect: scroll_effect, isHidden: isHidden, zIndex: zIndex },
            react_1.default.createElement(TopBar, null,
                react_1.default.createElement(MenuContainer, null,
                    react_1.default.createElement(ResponsiveLogo_1.default, { colorTheme: color_theme }),
                    react_1.default.createElement(Nav, null,
                        react_1.default.createElement(MenuGroup_1.default, { menuSet: first_set, isLoggedIn: isLoggedIn }),
                        react_1.default.createElement(Divider, { colorTheme: color_theme }),
                        react_1.default.createElement(MenuGroup_1.default, { menuSet: second_set, isLoggedIn: isLoggedIn }),
                        react_1.default.createElement(Button_1.default, { variant: "primary", display: { _: 'none', md: 'block' }, onClick: handleButtonClick, height: "61px", px: "30px", ml: exports.NAV_ITEM_MARGIN_SCALE }, hero_button === null || hero_button === void 0 ? void 0 : hero_button.label)),
                    react_1.default.createElement(MobileMenuIcon, { name: menuOpen ? 'ff-icon-clear' : 'ff-icon-menu', fontSize: "22px", onClick: function () { return setMenuOpen(!menuOpen); } }))),
            react_1.default.createElement(MobileNav, { className: menuOpen ? 'open' : '' },
                react_1.default.createElement(MobileMenuGroup_1.default, { menuSet: first_set.concat(second_set), isLoggedIn: isLoggedIn })),
            react_1.default.createElement(Button_1.default, { fullWidth: true, variant: "primary", display: { _: 'block', md: 'none' }, onClick: handleButtonClick, height: MOBILE_HERO_BUTTON_HEIGHT }, hero_button === null || hero_button === void 0 ? void 0 : hero_button.label)),
        react_1.default.createElement(Spacer, { colorTheme: color_theme })));
};
Header.defaultProps = defaultProps_1.default;
exports.default = Header;
